
export default {
    props: ['value', 'label', 'name', 'id', 'variant', 'required', 'disabled', 'placeholder', 'password', 'error', 'help', 'options', 'optionLabel', 'reduce', 'searchable', 'clearable', 'ariaLabel', 'invalid', 'describedBy'],
    methods: {
        updateValue(newValue){
            this.$emit('input', newValue);
        },
    },
    data() {
        return {
            isFocused: false,
        };
    },
}
